import { SecurityInfo as SecurityInfoModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface SecurityInfo extends SecurityInfoModel {
  udid: string;
}

export type SecurityInfoState = EntityState<SecurityInfo>;

export function selectId(securityInfo: SecurityInfo): string {
  return securityInfo.udid;
}

export const adapter: EntityAdapter<SecurityInfo> = createEntityAdapter<SecurityInfo>({
  selectId,
});

export const initialState: SecurityInfoState = adapter.getInitialState();
